export default __webpack_public_path__ + "static/media/2132.30ecdb91.png";